import { ColumnsType } from "antd/es/table";
import React, {Dispatch, MutableRefObject, SetStateAction} from "react";
import {
    ItemUnitModel,
    LookupItemModel,
    SearchItemRequestModel,
    SearchItemsTypeEnum, ItemModel,  UserConfigurationModel,
} from "../../../models";
import { generateGuid, getLabelName } from "../../../utils";
import {
    handleCalculatePrice,
    handleCalculatePriceWithTax,
    handleChangeItemUnitValues,
    handleDeleteItemUnitRow,
} from "../businessLogic/itemStoresBl";
import { TextBox, SelectBox, ButtonBox } from "../..";
import _ from "lodash";
import {TableColumn} from "react-data-table-component";

const headerStyle = {
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    lineHeight: '1.2',
    padding: '4px'
};
//#region dataTable
export const handleGenerateAntdItemUnitColumns = (
  tax: number,
  units: LookupItemModel[],
  setState: Dispatch<SetStateAction<ItemModel>>,
  isRefresh:boolean,
): ColumnsType<ItemUnitModel> => {
    const defaultUnit = units.find(p => p.otherValue?.isDefault === true);
    const defaultUnitId = defaultUnit?.value ?? null;
    const selectKey =isRefresh?generateGuid():"unit_"// Math.random() ;
  return [
    {
      title: "#",
      key: "index_" + generateGuid(),
        render(value, record, index) {
            return index + 1;
        },
        width: "3%"
    },
    {
      title: getLabelName("unit"),
      key: "unit_", //+generateGuid(),
        ellipsis:false,
        render: (row: ItemUnitModel) => (
            <SelectBox
                key={selectKey}
                selectedValues={
                    row.Unit_ID !== null && row.Unit_ID !== undefined && row.Unit_ID > 0
                        ? [row.Unit_ID.toString()]
                        :defaultUnitId !=null? [defaultUnitId.toString()]:null
                }
                isSingleSelect={true}
                labelName={""}
                source={units}
                onStatusChange={(e: LookupItemModel) => {
                    handleChangeItemUnitValues(
                        setState,
                        row.rowKey || `${row.ID}`,
                        [{key: "Unit_ID", value: e ? e.value : null}]
                    );
                }}
            />
        ),
        width: "30%", // Reduced width
        onHeaderCell: () => ({
            style: { whiteSpace: "normal", wordWrap: "break-word" }, // Enable header wrapping
        }),
    },
    {
      title: getLabelName("PriceSale"),
      key: "PriceSale_", //+generateGuid(),
      ellipsis:false,
      render: (row: ItemUnitModel) => (
        <TextBox
          labelName={""}
          inputName={"PriceSale"}
          type="number"
          inputValue={row.PriceSale}
          onChange={(e: any) => {
            handleChangeItemUnitValues(
              setState,
              row.rowKey || `${row.ID}`,
              [{key: "PriceSale", value: e.target.value},{key: "PriceSaleWithTax", value:handleCalculatePriceWithTax (e.target.value,tax)}]
            );
          }}
        />
      ),
        width: "5%", // Reduced width
        onHeaderCell: () => ({
            style: { whiteSpace: "normal", wordWrap: "break-word" }, // Enable header wrapping
        }),
    },
    {
      title: getLabelName("PriceSaleWithTax"),
      key: "PriceSaleWithTax", //+generateGuid(),
        ellipsis:false,
      render: (row: ItemUnitModel) => (
        <TextBox
          labelName={""}
          inputName={"PriceSaleWithTax"}
          type="number"
          inputValue={row.PriceSaleWithTax}
          onChange={(e: any) => {
            handleChangeItemUnitValues(
              setState,
              row.rowKey || `${row.ID}`,
              [{key: "PriceSaleWithTax", value: e.target.value},{key: "PriceSale", value: (e.target.value / (1 + tax / 100)).toFixed(2)}]
            );
          }}
        />
      ),
        width: "5%", // Reduced width
        onHeaderCell: () => ({
            style: { whiteSpace: "normal", wordWrap: "break-word" }, // Enable header wrapping
        }),
    },
    {
      title: getLabelName("PriceQutyBegBal"),
      key: "PriceQutyBegBal_", //+generateGuid(),
        ellipsis:false,
      render: (row: ItemUnitModel) => (
        <TextBox
          labelName={""}
          inputName={"PriceQutyBegBal"}
          type="number"
          inputValue={row.PriceQutyBegBal}
          onChange={(e: any) => {
            handleChangeItemUnitValues(
              setState,
              row.rowKey || `${row.ID}`,
              [{key: "PriceQutyBegBal", value: e.target.value},{key: "PriceQutyBegBalWithTax", value:  handleCalculatePriceWithTax(e.target.value ,tax)}]
            );
          }}
        />
      ),
        width: "5%", // Reduced width
        onHeaderCell: () => ({
            style: { whiteSpace: "normal", wordWrap: "break-word" }, // Enable header wrapping
        }),
    },
    {
      title: getLabelName("PriceQutyBegBalWithTax"),
      key: "PriceQutyBegBalWithTax_", //+generateGuid(),
        ellipsis:false,
      render: (row: ItemUnitModel) => (
        <TextBox
          labelName={""}
          inputName={"PriceQutyBegBalWithTax"}
          type="number"
          inputValue={row.PriceQutyBegBalWithTax}
          onChange={(e: any) => {
            handleChangeItemUnitValues(
              setState,
              row.rowKey || `${row.ID}`,
              [{key: "PriceQutyBegBalWithTax", value: e.target.value},{key: "PriceQutyBegBal", value:handleCalculatePrice (e.target.value,tax)}]
            );
          }}
        />
      ),
        width: "5%", // Reduced width
        onHeaderCell: () => ({
            style: { whiteSpace: "normal", wordWrap: "break-word" }, // Enable header wrapping
        }),
    },
    {
      title: getLabelName("QutyBegBal"),
      key: "QutyBegBal_", //+generateGuid(),
        ellipsis:false,
      render: (row: ItemUnitModel) => (
        <TextBox
          labelName={""} //{t("lookup.nameAr")}
          inputName={"QutyBegBal"}
          type="number"
          inputValue={row.QutyBegBal}
          onChange={(e: any) => {
            handleChangeItemUnitValues(
              setState,
              row.rowKey || `${row.ID}`,
              [{key: "QutyBegBal", value: e.target.value}]
            );
          }}
        />
      ),
        width: "5%", // Reduced width
        onHeaderCell: () => ({
            style: { whiteSpace: "normal", wordWrap: "break-word" }, // Enable header wrapping
        }),
    },
    {
      title: getLabelName("Factor"),
        ellipsis:false,
      key: "Factor_", //+generateGuid(),
      render: (row: ItemUnitModel) => (
        <TextBox
          labelName={""} //{t("lookup.nameAr")}
          inputName={"Factor"}
          type="number"
          inputValue={row.Factor}
          onChange={(e: any) => {
            handleChangeItemUnitValues(
              setState,
              row.rowKey || `${row.ID}`,
              [{key: "Factor", value: e.target.value}]
            );
          }}
        />
      ),
        width: "5%", // Reduced width
        onHeaderCell: () => ({
            style: { whiteSpace: "normal", wordWrap: "break-word" }, // Enable header wrapping
        }),
    },
    {
      title: getLabelName("Barcode"),
        ellipsis:false,
      key: "Barcode_", //+generateGuid(),
      render: (row: ItemUnitModel) => (
        <TextBox
          labelName={""} //{t("lookup.nameAr")}
          inputName={"Barcode"}
          type="number"
          inputValue={row.Barcode}
          onChange={(e: any) => {
            handleChangeItemUnitValues(
              setState,
              row.rowKey || `${row.ID}`,
              [{key: "Barcode", value: e.target.value}]
            );
          }}
        />
      ),
        width: "5%", // Reduced width
        onHeaderCell: () => ({
            style: { whiteSpace: "normal", wordWrap: "break-word" }, // Enable header wrapping
        }),
    },
    {
      title: getLabelName("IsSmallestUnit"),
        ellipsis:false,
      key: "IsSmallestUnit_", //+generateGuid(),
      render: (row: ItemUnitModel) => (
        <TextBox
          labelName={""} //{t("lookup.nameAr")}
          inputName={"IsSmallestUnit"}
          type="checkbox"
          inputValue={row.IsSmallestUnit}
          onChange={(e: any) => {
            handleChangeItemUnitValues(
              setState,
              row.rowKey || `${row.ID}`,
              [{key: "IsSmallestUnit", value: e.target.checked}]
            );
          }}
        />
      ),
        width: "5%", // Reduced width
        onHeaderCell: () => ({
            style: { whiteSpace: "normal", wordWrap: "break-word" }, // Enable header wrapping
        }),
    },
    {
      title: "",
      key: "action_", //+generateGuid(),
      render: (row: ItemUnitModel) => (
        <>
          <ButtonBox
            variant="outline-danger"
            onClick={() => {
              handleDeleteItemUnitRow(
                setState,
                row.rowKey || `${row.ID}`,
                row.rowKey !== undefined
              );
            }}
          >
            {getLabelName("Delete")}
          </ButtonBox>
        </>
      ),
    },
  ];
};
export const handleGenerateItemUnitColumns = (
    tax: number,
    units: LookupItemModel[],
    setState: Dispatch<SetStateAction<ItemModel>>,
    userConfiguration:UserConfigurationModel,
    isRefresh:boolean,
): TableColumn<ItemUnitModel>[] => {
    const defaultUnit = units.find(p => p.otherValue?.isDefault === true);
    const defaultUnitId = defaultUnit?.value ?? null;
    const selectKey =isRefresh?generateGuid():"unit_"// Math.random() ;
    let columns: TableColumn<ItemUnitModel>[] = [
        {
            name: getLabelName("unit"),
            cell: (row: ItemUnitModel, index)  => (
                <SelectBox
                    key={selectKey}
                    selectedValues={
                        row.Unit_ID !== null && row.Unit_ID !== undefined && row.Unit_ID > 0
                            ? [row.Unit_ID.toString()]
                            :defaultUnitId !=null? [defaultUnitId.toString()]:null
                    }
                    isSingleSelect={true}
                    labelName={""}
                    source={units}
                    onStatusChange={(e: LookupItemModel) => {
                        handleChangeItemUnitValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "Unit_ID", value: e ? e.value : null}]
                        );
                    }}
                />
            ),
            width: "20%",
        },
        {
            name: getLabelName("PriceSale"),
            cell: (row: ItemUnitModel)  => (
                <TextBox
                    labelName={""}
                    inputName={"PriceSale"}
                    type="number"
                    inputValue={row.PriceSale}
                    onChange={(e: any) => {
                        handleChangeItemUnitValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "PriceSale", value: e.target.value},{key: "PriceSaleWithTax", value:handleCalculatePriceWithTax (e.target.value,tax)}]
                        );
                    }}
                />
            ),
        },
        {
            id:"PriceSaleWithTax",
            name: getLabelName("PriceSaleWithTax"),
            cell: (row: ItemUnitModel, index)  => (
                <TextBox
                    labelName={""}
                    inputName={"PriceSaleWithTax"}
                    type="number"
                    inputValue={row.PriceSaleWithTax}
                    onChange={(e: any) => {
                        handleChangeItemUnitValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "PriceSaleWithTax", value: e.target.value},{key: "PriceSale", value: (e.target.value / (1 + tax / 100)).toFixed(2)}]
                        );
                    }}
                />
            ),
        },
        {
            name: getLabelName("PriceQutyBegBal"),
            cell: (row: ItemUnitModel, index)  => (
                <TextBox
                    labelName={""}
                    inputName={"PriceQutyBegBal"}
                    type="number"
                    inputValue={row.PriceQutyBegBal}
                    onChange={(e: any) => {
                        handleChangeItemUnitValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "PriceQutyBegBal", value: e.target.value},{key: "PriceQutyBegBalWithTax", value:  handleCalculatePriceWithTax(e.target.value ,tax)}]
                        );
                    }}
                />
            ),
        },
        {
            id:"PriceQutyBegBalWithTax",
            name: getLabelName("PriceQutyBegBalWithTax"),
            cell: (row: ItemUnitModel, index)  => (
                <TextBox
                    labelName={""}
                    inputName={"PriceQutyBegBalWithTax"}
                    type="number"
                    inputValue={row.PriceQutyBegBalWithTax}
                    onChange={(e: any) => {
                        handleChangeItemUnitValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "PriceQutyBegBalWithTax", value: e.target.value},{key: "PriceQutyBegBal", value:handleCalculatePrice (e.target.value,tax)}]
                        );
                    }}
                />
            ),
        },
        {
            name: getLabelName("QutyBegBal"),
            cell: (row: ItemUnitModel, index)  => (
                <TextBox
                    labelName={""} //{t("lookup.nameAr")}
                    inputName={"QutyBegBal"}
                    type="number"
                    inputValue={row.QutyBegBal}
                    onChange={(e: any) => {
                        handleChangeItemUnitValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "QutyBegBal", value: e.target.value}]
                        );
                    }}
                />
            ),
        },
        {
            name: getLabelName("Factor"),
            cell: (row: ItemUnitModel, index)  => (
                <TextBox
                    labelName={""} //{t("lookup.nameAr")}
                    inputName={"Factor"}
                    type="number"
                    inputValue={row.Factor}
                    onChange={(e: any) => {
                        handleChangeItemUnitValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "Factor", value: e.target.value}]
                        );
                    }}
                />
            ),
        },
        {
            name: getLabelName("Barcode"),
            cell: (row: ItemUnitModel, index)  => (
                <TextBox
                    labelName={""} //{t("lookup.nameAr")}
                    inputName={"Barcode"}
                    type="number"
                    inputValue={row.Barcode}
                    onChange={(e: any) => {
                        handleChangeItemUnitValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "Barcode", value: e.target.value}]
                        );
                    }}
                />
            )
        },
        {
            name: getLabelName("IsSmallestUnit"),
            cell: (row: ItemUnitModel, index)  => (
                <TextBox
                    labelName={""} //{t("lookup.nameAr")}
                    inputName={"IsSmallestUnit"}
                    type="checkbox"
                    inputValue={row.IsSmallestUnit}
                    onChange={(e: any) => {
                        handleChangeItemUnitValues(
                            setState,
                            row.rowKey || `${row.ID}`,
                            [{key: "IsSmallestUnit", value: e.target.checked}]
                        );
                    }}
                />
            ),
            width: "5%",
        },
        {
            name: "",
            cell: (row: ItemUnitModel, index)  => (
                <>
                    <ButtonBox
                        iconType="delete"
                        variant="danger"
                        type="button"
                        className="btn btn-sm"
                        onClick={() => {
                            handleDeleteItemUnitRow(
                                setState,
                                row.rowKey || `${row.ID}`,
                                row.rowKey !== undefined
                            );
                        }}
                    >
                        {/*{getLabelName("Delete")}*/}
                    </ButtonBox>
                </>
            ),
        },
    ];
    columns = !userConfiguration?.companySetting?.ApplyTax? columns.filter(column => column.id !== "PriceSaleWithTax"): columns;
    columns = !userConfiguration?.companySetting?.ApplyTax? columns.filter(column => column.id !== "PriceQutyBegBalWithTax"): columns;
    return  columns;
};
//#endregion
//#region header Search
export const handleGenerateSubHeaderComponent = (
  categoryList: LookupItemModel[],
  stateValue: SearchItemRequestModel,
  setState: Dispatch<SetStateAction<SearchItemRequestModel>>,
  filterSelectBoxMultiselectRef: MutableRefObject<any>,
  filterGroupSelectBoxMultiselectRef: MutableRefObject<any>,
  t: any
): React.ReactNode => {
  const handleSearch = (
    searchType: SearchItemsTypeEnum,
    searchValue?: string | null,
    category?: number | null
  ) => {
    const obj = { ...stateValue };
    //@ts-ignore
    const searchValueLength: number =
      searchValue !== null ? searchValue?.length : 0;
    const searchValueMiniLength: number = 3;
    if (
      obj.searchType !== searchType &&
      searchValue !== null &&
      searchValueLength >= searchValueMiniLength
    ) {
      obj.searchGuid = _.uniqueId("searchType_");
      obj.pageNumber = 1;
    }
    if (
      obj.searchValue !== searchValue &&
      (searchValueLength >= searchValueMiniLength || obj.searchValue === null)
    ) {
      obj.searchGuid = _.uniqueId("searchValue_");
      obj.pageNumber = 1;
    }
    if (obj.categoryId !== category) {
      obj.searchGuid = _.uniqueId("searchCategory_");
      obj.pageNumber = 1;
    }
    obj.searchType = searchType;
    obj.categoryId = category;
    obj.searchValue = searchValue;
    setState(obj);
  };
  return (
    <>
      <div className="row row-cols-xxl-3 row-cols-xl-3 row-cols-lg-3 row-cols-md-1 row-cols-sm-1 row-cols-1 g-md-4 g-sm-4">
        <SelectBox
          labelName={t("Search Criteria")}
          isSingleSelect={true}
          selectedValues={[stateValue.searchType]}
          source={[
            {
              name: t("Search By Name"),
              nameAr: t("Search By Name"),
              value: SearchItemsTypeEnum.ItemName,
            },
            {
              name: t("Search By Code"),
              nameAr: t("Search By Code"),
              value: SearchItemsTypeEnum.ItemCode,
            },
            {
              name: t("Search By BarCode"),
              nameAr: t("Search By BarCode"),
              value: SearchItemsTypeEnum.ItemBarCode,
            },
          ]}
          onStatusChange={(e: LookupItemModel) => {
            if (e != null) {
              handleSearch(
                Object.values(SearchItemsTypeEnum).filter(
                  (p) => p === e.value
                )[0],
                stateValue.searchValue,
                stateValue.categoryId
              );
            }
          }}
          multiselectRef={filterSelectBoxMultiselectRef}
        />
        <TextBox
          labelName={"Filter By"}
          inputName={"filterTextBox"}
          inputValue={stateValue.searchValue}
          onChange={(e: any) => {
            handleSearch(
              stateValue.searchType,
              e.target.value,
              stateValue.categoryId
            );
          }}
        />
        <SelectBox
          labelName={t("Category")}
          isSingleSelect={true}
          selectedValues={
            stateValue.categoryId !== null &&
            stateValue.categoryId !== undefined
              ? //@ts-ignore
                [searchItemRequest.categoryId.toString()]
              : null
          } //categoryfilter.map(String)
          source={categoryList}
          onStatusChange={(e: LookupItemModel) => {
            if (e != null) {
              handleSearch(
                stateValue.searchType,
                stateValue.searchValue,
                Number(e.value)
              );
            }
          }}
          multiselectRef={filterGroupSelectBoxMultiselectRef}
        />
      </div>
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end my-3">
        <ButtonBox
          variant="danger"
          type="button"
          className="btn btn-sm"
          onClick={() => {
            filterSelectBoxMultiselectRef.current.clearValue();
            filterGroupSelectBoxMultiselectRef.current.clearValue();
            handleSearch(stateValue.searchType, "", null);
          }}
        >
          {t("reset")}
        </ButtonBox>
      </div>
    </>
  );
};
//#endregion
